export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/b3dc542ec1b5794376b3d1da54a4e35b.svg";